import apiClient from './client';

export const getDailyQuests = () => apiClient.get('/api/quests/');
export const reportQuestProgress = (questType, increment = 1) =>
  apiClient.post('/api/quests/progress', { quest_type: questType, increment });
export const getQuestHistory = (days = 7) =>
  apiClient.get(`/api/quests/history?days=${days}`);
